module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_1536.36ef8176.webp";